import styled from "styled-components";

export const ModalObservation = styled.div`
  padding: 0.5rem;

  @media(min-width: 768px) {
    padding: 1rem 1.5rem 1.5rem 1.5rem;
  }

  div {
    display: flex;
    justify-content: space-between;
  }

  h4 {
    font-size: 1rem;
    color: #000FFF;
    font-weight: 500;
  }

  textarea {
    width: 100%;
    border: 1px solid #00000034;
    border-radius: .5rem;
    resize: none;
    padding: .5rem;
    height: 8rem;
    margin: .5rem 0 0 0;
  }
`;

export const ObservationContent = styled.div`
  padding: 1rem;
  font-size: .88rem;
  color: #707070;
`;

export const CardHeader = {
  backgroundColor: "rgb(230, 223, 223)",
  color: "rgb(112, 112, 112)",
  fontSize: ".9rem",
  fontWeight: "550",
  padding: ".2rem 1rem",
  borderTopLeftRadius: ".3rem",
  borderTopRightRadius: ".3rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  boxShadow: '0px 2px 4px #00000033'
};

export const ObservationMobile = styled.div`
  @media(min-width: 770px) {
    display: none;
  }
`;

export const ObservationDesktop = styled.div`
  @media(max-width: 770px) {
    display: none;
  }
`;

export const AddIconStyles = {
  fontWeight: "600",
  fontSize: "1.7rem",
}

export const MinimizeIconStyles = {
  fontWeight: "600",
  fontSize: "1.7rem",
  marginTop: "-0.85rem",
}

export const ButtonOutline = styled.button`
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  width: 100%;
  height: 38px;
  background-color: ${(props) => (props.outline ? "transparent" : "#000FFF")};
  border-radius: 10px;
  color: ${(props) => (props.outline ? "#000FFF" : "#ffffff")};
  text-align: center;
  border: ${(props) => (props.outline ? "2px solid #000FFF" : "0")};
  overflow: hidden;
  box-shadow: ${(props) => (props.outline ? "0px 3px 8px #00000040" : "0px 3px 8px #00000059")};
  border-radius: ${(props) => (props.outline ? "8px" : "10px")};
  transition: 0.5s;
  &:hover {
    filter: brightness(85%);
  }
  img {
    float: left;
    padding-left: 0.7rem;
  }
  span {
    padding-right: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
